<template>
    <vs-select 
      v-model="selectedOption" 
      @input="onOptionChanged" 
      id="multi-month-filter"
      class="w-full"
    >
        <vs-select-item v-for="item in items" :key="item.value" :value="item.value" :text="item.text" />
    </vs-select>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      selectedOption: null,
      items: []
    };
  },
  methods: {
    onOptionChanged() {
      this.params.handleFilter({
        [this.params.columnName]: this.selectedOption,
      });
    },
  },
  mounted() {
    // If the filter is not applied, set the selected option to null
    const values = this.params.getValues()
    // If the filter is applied, set the selected option to the value of the filter
    if (values[this.params.columnName] !== null && values[this.params.columnName] !== undefined) {
      this.selectedOption = values[this.params.columnName]
    }else if (this.params.defaultValue !== null) {
      this.selectedOption = this.params.defaultValue
    }

    if (this.params.items) {
      this.items = this.params.items
    }else {
      this.items = [
        {value: null, text: 'Todos'},
        {value: 1, text: 'Sí'},
        {value: 0, text: 'No'},
      ]
    }
  }
});
</script>
